import type { ReactNode } from "react";

import { ArrowBackIcon } from "../../icons/arrow-back";
import { CloseIcon } from "../../icons/close";
import { Button } from "../button";

import styles from "./fullscreen-layout.module.css";

type WithBackButton =
	{ prev: () => void; showBackButton: true } | { prev?: () => void; showBackButton: false };

type FullscreenLayoutProps = {
	children: ReactNode;
	onClose: () => void;
} & WithBackButton;

export function FullscreenLayout({
	children,
	onClose,
	prev,
	showBackButton,
}: FullscreenLayoutProps): ReactNode {
	return (
		<section className={styles.fullscreen}>
			<header className={styles.header}>
				{showBackButton && (
					<Button
						data-testid="flow-back-button"
						iconOnly
						onPress={prev}
						variant="secondary"
					>
						<ArrowBackIcon />
					</Button>
				)}
				<Button
					data-testid="flow-close-button"
					iconOnly
					onPress={onClose}
					variant="secondary"
				>
					<CloseIcon />
				</Button>
			</header>
			<div className={styles.content}>{children}</div>
		</section>
	);
}
